import {
  DqCard,
  DqSidePanel,
  DqSidePanelContent,
  DqSidePanelTitle,
} from "@decentriq/components";
import { faUser } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chip, Divider, Stack, Typography } from "@mui/joy";
import { memo, useMemo } from "react";
import {
  type MediaDataRoomParticipant,
  mediaDataRoomParticipantRoleCardPresentation,
} from "features/mediaDataRoom/models";

interface MediaDataRoomConfigurationParticipantDrawerProps {
  participant: MediaDataRoomParticipant | null;
  onClose: () => void;
}

const MediaDataRoomConfigurationParticipantDrawer =
  memo<MediaDataRoomConfigurationParticipantDrawerProps>(
    ({ participant, onClose }) => {
      const participantRoleLabel = useMemo(
        () =>
          participant
            ? `${mediaDataRoomParticipantRoleCardPresentation[participant.role].title}${participant?.isCurrentUser ? " (You)" : ""}`
            : null,
        [participant]
      );
      return (
        <DqSidePanel.Floating onClose={onClose} open={Boolean(participant)}>
          <DqSidePanelTitle
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            {participant?.name}
          </DqSidePanelTitle>
          <Divider inset="context" />
          <DqSidePanelContent>
            <Stack>
              <DqCard>
                <Typography
                  gutterBottom={true}
                  level="body-sm"
                  textColor="inherit"
                >
                  <strong>Role</strong>
                </Typography>
                <Chip>{participantRoleLabel}</Chip>
              </DqCard>
              <DqCard>
                <Typography
                  gutterBottom={true}
                  level="body-sm"
                  textColor="inherit"
                >
                  <strong>Emails</strong>
                </Typography>
                <Stack>
                  {participant?.emails.map((email) => (
                    <Typography
                      key={email}
                      level="body-sm"
                      startDecorator={
                        <FontAwesomeIcon
                          fixedWidth={true}
                          icon={faUser}
                          size="lg"
                        />
                      }
                      textColor="inherit"
                    >
                      {email}
                    </Typography>
                  ))}
                </Stack>
              </DqCard>
            </Stack>
          </DqSidePanelContent>
        </DqSidePanel.Floating>
      );
    }
  );
MediaDataRoomConfigurationParticipantDrawer.displayName =
  "MediaDataRoomConfigurationParticipantDrawer";

export default MediaDataRoomConfigurationParticipantDrawer;
